module.exports = __webpack_public_path__ + "img/tree2_2021.14846830.gif";